<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            :validations="validations.unidade"
                            @change="handleUnidadeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            :validations="validations.infraestrutura"
                            @change="handleInfraestruturaChange"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.especialidades"
                            :validations="validations.especialidade"
                            @change="handleEspecialidadeChange"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.usuarios"
                            :validations="validations.usuario"
                            @change="handleUsuarioChange"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.statusId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>

                <rkm-row
                    v-for="(atendimento, index) in data.atendimentos"
                    :key="index"
                >
                    <rkm-col
                        class="mb-2"
                        cols="12"
                    >
                        <rkm-list-group>
                            <rkm-list-group-item class="rkm-list-group-item">
                                <rkm-row>
                                    <rkm-col>
                                        <strong>Tipo de demanda: </strong>{{atendimento.demandaTipo}}
                                    </rkm-col>

                                    <rkm-col>
                                        <strong>Especialista: </strong>{{atendimento.usuarioNome}}
                                    </rkm-col>

                                    <rkm-col>
                                        <strong>Especialidade: </strong>{{atendimento.especialidadeNome}}
                                    </rkm-col>

                                    <rkm-col>
                                        <strong>Data: </strong>{{atendimento.data}}
                                    </rkm-col>
                                </rkm-row>
                            </rkm-list-group-item>
                        </rkm-list-group>

                        <rkm-collapse
                            class="rkm-collapse"
                            visible
                        >
                            <rkm-row class="p-2">
                                <rkm-col cols="12">
                                    <rkm-table
                                        :fields="fields"
                                        :items="atendimento.consultas"
                                        hide-filters
                                        hide-pagination
                                    >
                                        <template v-slot:cell(cids)="{item}">
                                            <div
                                                v-for="(cid, index) in item.cids"
                                                :key="index"
                                            >
                                                {{cid.codigo}}
                                            </div>
                                        </template>

                                        <template v-slot:cell(procedimentos)="{item}">
                                            <div
                                                v-for="(procedimento, index) in item.procedimentos"
                                                :key="index"
                                            >
                                                <div v-for="(codigo, codigoIndex) in procedimento.codigo.split(',')" :key="codigoIndex">
                                                    {{ codigo.trim() }}
                                                    <br v-if="codigoIndex < procedimento.codigo.split(',').length - 1" />
                                                </div>
                                            </div>
                                        </template>

                                        <template v-slot:custom-foot>
                                            <rkm-tr>
                                                <rkm-th>Pacientes: {{atendimento.quantidadePacientes}}</rkm-th>
                                                <rkm-th colspan="2">Realizadas: {{atendimento.quantidadeAtendimentosRealizados}}</rkm-th>
                                                <rkm-th colspan="2">Faltas: {{atendimento.quantidadeFaltas}}</rkm-th>
                                                <rkm-th>Procedimentos lançados: {{atendimento.quantidadeProcedimentosLancados}}</rkm-th>
                                            </rkm-tr>
                                        </template>
                                    </rkm-table>
                                </rkm-col>
                            </rkm-row>
                        </rkm-collapse>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Totais"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.quantidadePacientes"
                            disabled
                            label="Pacientes"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.quantidadeAtendimentosRealizados"
                            disabled
                            label="Realizadas"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.quantidadeFaltas"
                            disabled
                            label="Faltas"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.quantidadeProcedimentosLancados"
                            disabled
                            label="Procedimentos lançados"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                unidade: {required: true},
                infraestrutura: {required: true},
                especialidade: {required: true},
                usuario: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            relatorioConsultaFinalizada: this.getConectaSusRepository('ambulatorio.relatorioConsultaFinalizada'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            fields: [
                {key: 'pacienteNome', label: 'Paciente', sortable: true},
                {key: 'pacienteProntuario', label: 'Prontuário', sortable: true},
                {key: 'agendamentoHorario', label: 'Horário', sortable: true},
                {key: 'cids', label: 'CID'},
                {key: 'procedimentos', label: 'Procedimento'},
                {key: 'agendamentoStatusNome', label: 'Status', sortable: true},
            ],
            data: null,
            model: null,
            others: {moment},
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioConsultaFinalizada.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
            }

            this.setLoading()

            this.repositories.relatorioConsultaFinalizada.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null

            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
            }

            this.repositories.impressao.relatorioConsultaFinalizada(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioConsultaFinalizada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.infraestruturas = Object.assign(response.data.infraestruturas))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'especialidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioConsultaFinalizada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.especialidades = Object.assign(response.data.especialidades))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.statusId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioConsultaFinalizada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.usuarios = Object.assign(response.data.usuarios))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.status = []
            this.model.statusId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'status',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioConsultaFinalizada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.status = Object.assign(response.data.status))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.especialidades = []
                this.form.usuarios = []
                this.form.status = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.model.statusId = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioConsultaFinalizada.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => this.form.unidades = Object.assign(response.data.unidades))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>